import { dashboardModalTypes } from './dashboardModalTypes';


export const dashboardModalConfig = [
    {
        modalType: dashboardModalTypes.CHANGE_PLANS_MODAL,
        modalId: 'change-plans-modal',
        modalHeaderTextData: null
    },
    {
        modalType: dashboardModalTypes.APP_STATUS_CLOSED_MODAL,
        modalId: 'app-status-closed-modal',
        modalHeaderTextData: 'appstatus.closed.header'
    },
    {
        modalType: dashboardModalTypes.QHP_INELIGIBLE_MODAL,
        modalId: 'QHP-ineligible-modal',
        modalHeaderTextData: null
    },
    {
        modalType: dashboardModalTypes.CANCEL_APP_MODAL,
        modalId: 'cancel-app-modal',
        modalHeaderTextData: 'modal.cancel_app_header'
    },
    {
        modalType: dashboardModalTypes.EXEMPTION_NUMBER_MODAL,
        modalId: 'exemption-number-modal',
        modalHeaderTextData: 'indportal.tobacco.noHardshipExemptNo.modal.header'
    },
    {
        modalType: dashboardModalTypes.FAILURE_MODAL,
        modalId: 'failure-modal',
        modalHeaderTextData: 'common.technical_issues'
    },
    {
        modalType: dashboardModalTypes.GET_ASSISTANCE,
        modalId: 'get-assistance-modal',
        modalHeaderTextData: 'modals.header.get_assistance'
    },
    {
        modalType: dashboardModalTypes.CREATE_TICKET_MODAL,
        modalId: 'create-ticket-modal',
        modalHeaderTextData: null
    },
    {
        modalType: dashboardModalTypes.VERIFY_PHONE_MODAL,
        modalId: 'verify-phone-modal',
        modalHeaderTextData: 'modals.header.phone_verify'
    },
    {
        modalType: dashboardModalTypes.VERIFY_EMAIL_MODAL,
        modalId: 'verify-email-modal',
        modalHeaderTextData: 'modals.header.verify_email'
    },
    {
        modalType: dashboardModalTypes.CHANGE_PHONE_MODAL,
        modalId: 'change-phone-modal',
        modalHeaderTextData: 'modals.header.phone_change'
    },
    {
        modalType: dashboardModalTypes.CHANGE_EMAIL_MODAL,
        modalId: 'change-email-modal',
        modalHeaderTextData: 'modals.header.email_change'
    },
    {
        modalType: dashboardModalTypes.MAILING_ADDRESS_UPDATING_MODAL,
        modalId: 'mailing-address-updating-modal',
        modalHeaderTextData: 'modals.header.update_mailing_address',
        bodyId: 'mailingAddressUpdatingModal'
    },
    {
        modalType: dashboardModalTypes.FILE_SIZE_EXCEEDING_ERROR_MODAL,
        modalId: 'file-size-exceeding-error-modal',
        modalHeaderTextData: null
    },
    {
        modalType: dashboardModalTypes.OVERRIDE_COMMENT_MODAL,
        modalId: 'override-comment-modal',
        modalHeaderTextData: 'modals.header.override_comment',
        formName: 'overrideCommentModalForm'
    },
    {
        modalType: dashboardModalTypes.REUSE_PRIOR_APP,
        modalId: 'reuse-prior-submitted-app',
        modalHeaderTextData: null
    },
    {
        modalType: dashboardModalTypes.PICK_DIFF_PLAN,
        modalId: 'pick-diff-id',
        modalHeaderTextData: null
    },
];
